import axios from 'axios'
import { 
    ENCODE_REQUEST,
    ENCODE_SUCCESS,
    ENCODE_FAIL,
    GENERATE_REPORT_REQUEST,
    GENERATE_REPORT_SUCCESS,
    GENERATE_REPORT_FAIL,
    RESET_GENERATED_PCR,
    APPLY_TEMPLATE_REQUEST,
    APPLY_TEMPLATE_SUCCESS,
    APPLY_TEMPLATE_FAIL,
    CONCISE_REPORT_REQUEST,
    CONCISE_REPORT_SUCCESS,
    CONCISE_REPORT_FAIL,
    REPORT_FEEDBACK_REQUEST,
    REPORT_FEEDBACK_SUCCESS,
    REPORT_FEEDBACK_FAIL,
    RECLASSIFY_REQUEST,
    RECLASSIFY_SUCCESS,
    RECLASSIFY_FAIL,
    GENERATE_LAB_REQUEST,
    GENERATE_LAB_SUCCESS,
    GENERATE_LAB_FAIL,
} from '../constants/encodeConstants'

export const encodeMP3 = (file) => async(dispatch) => {
    dispatch({
        type: ENCODE_REQUEST
    })

    try {
        if (file.size > 1000000) {
            throw new Error('File is too large')
        }

        const formData = new FormData();
        formData.append('file', file);

        // Send to server
        const { data } = await axios.post(process.env.REACT_APP_GOLANGAPI + '/api/encode', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        
        dispatch({
            type: ENCODE_SUCCESS,
            payload: data,
        })
    }
    catch(error) {
        dispatch({
            type: ENCODE_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}

export const generateReport = (text, userId, reportTypeId) => async(dispatch) => {
    dispatch({
        type: RESET_GENERATED_PCR
    })

    dispatch({
        type: GENERATE_REPORT_REQUEST
    })

    try {
        if (text.length > 10000) {
            throw new Error('Text is too large.')
        }

        const config = {
            headers:{
                'Content-type': 'application/json',
            }
        }

        console.log(process.env.REACT_APP_GOLANGAPI + '/api/report')
        
        const { data } = await axios.post(
            process.env.REACT_APP_GOLANGAPI + '/api/report',
            {
                userId: userId,
                reportTypeId: reportTypeId,
                text: text,
           },
            config
        )

        dispatch({
            type: GENERATE_REPORT_SUCCESS,
            payload: data,
        })
    }
    catch (error) {
        dispatch({
            type: GENERATE_REPORT_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}

export const applyTemplate = (text, userId, reportTypeId, templateId, reportConfig) => async(dispatch) => {
    dispatch({
        type: APPLY_TEMPLATE_REQUEST
    })

    try {
        if (text.length > 10000) {
            throw new Error('Text is too large')
        }

        const config = {
            headers:{
                'Content-type': 'application/json',
            }
        }

        const { data } = await axios.post(
            process.env.REACT_APP_GOLANGAPI + '/api/template/apply/' + templateId,
            {
                text: text,
                userId: userId,
                reportTypeId: reportTypeId,
                reportConfig: reportConfig,
            },
            config
        )

        dispatch({
            type: APPLY_TEMPLATE_SUCCESS,
            payload: data,
        })
    }
    catch (error) {
        dispatch({
            type: APPLY_TEMPLATE_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}

export const conciseReport = (text, userId, reportTypeId) => async(dispatch) => {
    dispatch({
        type: CONCISE_REPORT_REQUEST
    })

    try {
        if (text.length > 10000) {
            throw new Error('Text is too large')
        }

        const config = {
            headers:{
                'Content-type': 'application/json',
            }
        }

        const { data } = await axios.post(
            process.env.REACT_APP_GOLANGAPI + '/api/concise',
            {
                text: text,
                userId: userId,
                reportTypeId: reportTypeId,
            },
            config
        )

        dispatch({
            type: CONCISE_REPORT_SUCCESS,
            payload: data,
        })
    }
    catch (error) {
        dispatch({
            type: CONCISE_REPORT_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}

export const feedbackReport = (text, userId, reportTypeId, reportConfig) => async(dispatch) => {
    dispatch({
        type: REPORT_FEEDBACK_REQUEST
    })

    try {
        if (text.length > 10000) {
            throw new Error('Text is too large')
        }

        const config = {
            headers:{
                'Content-type': 'application/json',
            }
        }

        const { data } = await axios.post(
            process.env.REACT_APP_GOLANGAPI + '/api/feedback',
            {
                text: text,
                userId: userId,
                reportTypeId: reportTypeId,
                reportConfig: reportConfig,
            },
            config
        )

        dispatch({
            type: REPORT_FEEDBACK_SUCCESS,
            payload: data,
        })
    }
    catch (error) {
        dispatch({
            type: REPORT_FEEDBACK_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}

export const reclassify = (userId, reportTypeId, original, modified) => async(dispatch) => {
    dispatch({type: RECLASSIFY_REQUEST})

    try {

        const config = {
            headers:{
                'Content-type': 'application/json',
            }
        }

        const { data } = await axios.post(
            process.env.REACT_APP_GOLANGAPI + '/api/reclassify',
            {
                userId: userId,
                reportTypeId: reportTypeId,
                original: original,
                modified: modified,
            },
            config
        )
        dispatch({type: RECLASSIFY_SUCCESS})
    }
    catch (error) {
        dispatch({type: RECLASSIFY_FAIL})
    }
}

export const generateLab = (input, template, userId, templateId) => async(dispatch) => {
    dispatch({
        type: GENERATE_LAB_REQUEST
    })

    try {

        const config = {
            headers:{
                'Content-type': 'application/json',
            }
        }

        const { data } = await axios.post(
            process.env.REACT_APP_GOLANGAPI + '/api/shorthand',
            {
                input: input,
                template: template,
                userId: userId,
                templateId: templateId,
                reportTypeId: 2,
            },
            config
        )

        dispatch({
            type: GENERATE_LAB_SUCCESS,
            payload: data,
        })
    }
    catch (error) {
        dispatch({
            type: GENERATE_LAB_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}